module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.received) ? _c('div', {
    staticClass: "article-view"
  }, [_c('h2', {
    staticClass: "article-view-title"
  }, [_vm._v(_vm._s(_vm.articleTitle))]), _vm._v(" "), _c('p', {
    staticClass: "article-view-meta"
  }, [_vm._v("\n        Created " + _vm._s(_vm.articleTime) + "\n      ")]), _vm._v(" "), _c('vue-markdown', {
    staticClass: "article-view-content",
    attrs: {
      "source": _vm.articleContent
    },
    on: {
      "rendered": _vm.highlight
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "article-view-control"
  }, [_c('router-link', {
    class: {
      disabled: _vm.previousDisable
    },
    attrs: {
      "id": "prev",
      "to": {
        name: 'article',
        params: {
          id: _vm.targetPreviousID
        }
      }
    }
  }, [_vm._v("Prev")]), _vm._v(" "), _c('router-link', {
    class: {
      disabled: _vm.nextDisable
    },
    attrs: {
      "id": "next",
      "to": {
        name: 'article',
        params: {
          id: _vm.targetNextID
        }
      }
    }
  }, [_vm._v("Next ")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.received) ? _c('loading') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-826d5f2a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/article-view.vue
// module id = 360
// module chunks = 0